import { InjectionToken } from '@angular/core';

export let AppConfigToken = new InjectionToken("IAppConfig");
export let OAuthConfigToken = new InjectionToken("IOAuthConfig");
export let BaseURI = new InjectionToken("BaseURI");
export let APIBaseURI = new InjectionToken("APIBaseURI");